
/* injects from baggage-loader */

const navigationFieldsDirective = angular.module('navigationfields.setting', []);

navigationFieldsDirective.directive("navigationFieldsSetting", [
  "$window", "$timeout", "$compile", "$templateCache", "ns", "translitService", "Widget", "blockEditDialog", "$rootScope", "$state", "Modal",
  ($window, $timeout, $compile, $templateCache, ns, translitService, Widget, blockEditDialog, $rootScope, $state, Modal) => {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel"
      },
      templateUrl: settingFolder + "/navigationfields/template.jade",
      link: (scope, element, attrs, ngModel) => {
        const id = attrs.widgetId;
        const widgetElWrapper = angular.element("[data-block-id=" + id + "]").find(ns.widgetWrapperClass);

        scope.createLink = Modal.createLink;
        scope.editLink = Modal.editLink;
        scope.treeOptions = {
          dropped: (e) => {
            _.each(scope.data.links_attributes, (node, index) => {
              if (node._destroy) {
                index--;
              }
              node.has_parent = false;
              node.parent_id = null;
              node.position = index;
              _.each(node.links_attributes, (node2, index2) => {
                if (node2._destroy) {
                  index--;
                }
                node2.position = index2;
                if (node2.id === e.source.nodeScope.$modelValue.id) {
                  node2.parent_id = node.id;
                  node2.has_parent = true;
                }
              });
            });
          }
        };
        scope.deleteLink = (link) => {
          link._destroy = true;
        };
        scope.linksLength = () => {
          const destroyed = _.filter(scope.data.links_attributes, {
            _destroy: true
          });
          return scope.data.links_attributes.length - destroyed.length;
        };

        /**
         * Переустановка позиций у ссылок
         * @param newVal
         */
        const reorderLinks = (newVal) => {
          _.each(newVal.links_attributes, (link, index) => {
            link.position = index;
            _.each(link.links_attributes, (sublink, index) => {
              sublink.position = index;
            });
          });
        };

        /**
         * Рендер ссылок
         * @param newVal
         */
        const renderLinks = (newVal) => {
          widgetElWrapper.find("ul:first").html("");

          _.each(newVal.links_attributes, (link) => {
            let linkHTML = "";
            let sublinksHTML = "";

            if (!link._destroy) {
              _.each(link.links_attributes, (sublink) => {
                if (!sublink._destroy) {
                  sublinksHTML += (
                    "<li class='str-nav__li'>" +
                      "<a class='str-nav__a' href='javascript: void(0)'>" + sublink.name + "</a>" +
                    "</li>"
                  );
                }
              });

              linkHTML = (
                "<li class='str-nav__li str-nav__li_inline'>" +
                  "<a class='str-nav__a' href='javascript: void(0)'>" + link.name + "</a>" +
                  "<ul class='str-nav__list'>" + sublinksHTML + "</ul>" +
                "</li>"
              );
            }

            widgetElWrapper.find("ul:first").append(linkHTML);
          });
        };

        /**
         * Установка стилей для ссылок
         * @param newVal
         */
        const setLinksStyle = (newVal) => {
          widgetElWrapper.find(".str-nav__a").css(newVal);
        };

        const listener1 = scope.$watch("data", function(newVal, oldVal) {
          reorderLinks(newVal);
          renderLinks(newVal);
          setLinksStyle(newVal.link_style);
        }, true);

        scope.$on("$destroy", () => {
          return listener1();
        });
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/navigationfields/navigationfields.directive.js